import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store, useAppSelector } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
function ThemeRoot() {
  const mode = useAppSelector((s) => s.theme.mode);
  useEffect(() => {
    const rootEl = document.documentElement;
    if (mode === 'dark') rootEl.classList.add('dark');
    else rootEl.classList.remove('dark');
  }, [mode]);
  return <App />;
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeRoot />
    </Provider>
  </React.StrictMode>
);

